import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {addQuery, getUUID} from '@yandex-delivery/utils'

import type {CreateDCAARepositoryArguments, DcaaRepository} from './types'

export function createDcaaRepository(params: CreateDCAARepositoryArguments): DcaaRepository {
  const {fetch} = params

  return {
    fetchPaymentMethods(appConfig, body) {
      return fetch(appConfig, {
        method: 'POST',
        url: addQuery(externalApiURL('cargo/v1/corp/employee/payment-methods/list'), {country: appConfig.countryCode}),
        body,
      })
    },
    fetchForm(appConfig, body) {
      return fetch(appConfig, {
        method: 'POST',
        url: addQuery(externalApiURL('dcaa/delivery/v1/form'), {country: appConfig.countryCode}),
        headers: {
          'X-Device-Type': appConfig.device,
        },
        body,
      })
    },
    fetchAcceptOfferBase(appConfig, body) {
      return fetch(appConfig, {
        method: 'POST',
        url: addQuery(externalApiURL('dcaa/delivery/v1/offers/accept'), {
          request_id: getUUID(),
          country: appConfig.countryCode,
        }),
        body,
      })
    },
    fetchSharingBase(appConfig, body) {
      return fetch(appConfig, {
        method: 'POST',
        url: addQuery(externalApiURL('dcaa/v1/sharing'), {country: appConfig.countryCode}),
        body,
      })
    },
    fetchSafeFlowChallenge(appConfig) {
      return fetch(appConfig, {
        method: 'POST',
        url: addQuery(externalApiURL('dcaa/v1/client/employee/challenge/pass/'), {country: appConfig.countryCode}),
      })
    },
  }
}
